import i18n from "./i18n";

const completeAction = async (id, data) => {
  const formData = new FormData();
  formData.append("authenticity_token", window.authToken());
  formData.append("completed_year", data["completed_year"]);
  formData.append("final_cost", data["final_cost"]);
  formData.append("comment", data["comment"]);

  try {
    const response = await fetch(`/actions/${data.id}/complete`, {
      // Does not use API
      method: "PUT",
      body: formData,
      credentials: "same-origin",
    });
    return response.ok;
  } catch (e) {
    return false;
  }
};

const getFilterQueryObject = (filters) => ({
  start_year: filters.startYear,
  end_year: filters.endYear,
  from_total_price: filters.fromTotalPrice,
  to_total_price: filters.toTotalPrice,
  text: filters.text,
  investment_rate: filters.investmentRate,
  status: filters.status,
  vat_rate: filters.vatRate,
  category_name: filters.category_name,
  location: filters.location,
  building: filters.building,
  plan_selection_list: filters.planSelectionList,
  tag_list: filters.tag_list,
  tag_ids: filters.tagIds,
  project: filters.project,
  budget: filters.budget,
  is_energy_saving: filters.isEnergySaving,
  carbon_dioxide_equivalent: filters.carbonDioxideEquivalent,
  suggestion: filters.suggestion,
  facility_component: filters.facilityComponent,
  connected_to_suggestion: filters.connectedToSuggestion,
});

const STATUS_OPTIONS = [
  {
    value: "planned",
    label: i18n.t("js.lib.maintenance_plan_action.status_options.planned"),
  },
  {
    value: "prioritized",
    label: i18n.t("js.lib.maintenance_plan_action.status_options.prioritized"),
  },
  {
    value: "deferred",
    label: i18n.t("js.lib.maintenance_plan_action.status_options.deferred"),
  },
  {
    value: "decided",
    label: i18n.t("js.lib.maintenance_plan_action.status_options.decided"),
  },
  {
    value: "in_progress",
    label: i18n.t("js.lib.maintenance_plan_action.status_options.in_progress"),
  },
  {
    value: "completed",
    label: i18n.t("js.lib.maintenance_plan_action.status_options.completed"),
  },
  {
    value: "inactive",
    label: i18n.t("js.lib.maintenance_plan_action.status_options.inactive"),
  },
  {
    value: "draft",
    label: i18n.t("js.lib.maintenance_plan_action.status_options.draft"),
  },
];

export { completeAction, getFilterQueryObject, STATUS_OPTIONS };
